import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f51828c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { for: "writerCompanyName" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "writerName" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "writerEmail" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "writerPhoneNumber" }
const _hoisted_11 = { class: "section-title" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { for: "leadCompanyName" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { for: "leadContactFirstName" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { for: "leadContactLastName" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { for: "leadContactEmail" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { for: "leadContactPhoneNumber" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "leadDescription" }
const _hoisted_24 = { class: "form-actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('referrallead.form.title')), 1),
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("section", null, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('referrallead.form.writer.header')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('referrallead.form.writer.company.name')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.form.writerCompanyName) = $event)),
            id: "writerCompanyName",
            type: "text",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.form.writerCompanyName]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('referrallead.form.writer.name')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.form.writerName) = $event)),
            id: "writerName",
            type: "text",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.form.writerName]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('referrallead.form.writer.email')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.form.writerEmail) = $event)),
            id: "writerEmail",
            type: "email",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.form.writerEmail]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('referrallead.form.writer.phone')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.form.writerPhoneNumber) = $event)),
            id: "writerPhoneNumber",
            type: "tel"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.writerPhoneNumber]
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('referrallead.form.lead.header')), 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('referrallead.form.lead.company.name')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vm.form.leadCompanyName) = $event)),
            id: "leadCompanyName",
            type: "text",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadCompanyName]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('referrallead.form.lead.contact.firstname')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vm.form.leadContactFirstName) = $event)),
            id: "leadContactFirstName",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadContactFirstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('referrallead.form.lead.contact.lastname')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vm.form.leadContactLastName) = $event)),
            id: "leadContactLastName",
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadContactLastName]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('referrallead.form.lead.contact.email')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vm.form.leadContactEmail) = $event)),
            id: "leadContactEmail",
            type: "email"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadContactEmail]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('referrallead.form.lead.contact.phone')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.vm.form.leadContactPhoneNumber) = $event)),
            id: "leadContactPhoneNumber",
            type: "tel"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadContactPhoneNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('referrallead.form.lead.description')), 1),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.vm.form.leadDescription) = $event)),
            id: "leadDescription",
            rows: "4"
          }, null, 512), [
            [_vModelText, _ctx.vm.form.leadDescription]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.isSubmitting
        }, [
          (_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('referrallead.form.button.send')) + "...", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('referrallead.form.button.send')), 1))
        ], 8, _hoisted_25)
      ])
    ], 32)
  ]))
}